// DTM
import React, { Component } from "react";
import { connect } from "react-redux";
import styled from "styled-components";

import Lot, { lotCutOff } from "./Lot";

const Wrapper = styled.div`
  width: 100%;
  float: left;
  position: relative;
  padding-top: 99px;
  @media (min-width: 1400px) {
    width: 1400px;
    padding: 99px calc(50% - 700px) 0 calc(50% - 700px);
  }
  @media (max-width: 1100px) {
    padding-top: 52px;
  }
  @media (max-width: 700px) {
    padding: 0;
  }
`;
const Title = styled.div`
  position: absolute;
  top: 37px;
  left: calc(50% - 520px);

  height: 58px;
  font-family: Lato;
  font-size: 42px;
  font-weight: 900;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.38;
  letter-spacing: 0.6px;
  color: rgba(0, 0, 0, 0.85);
  @media (max-width: 1100px) {
    left: 25px;
    top: 8px;

    height: 58px;
    font-size: 27px;
    line-height: 2.15;
    letter-spacing: 0.4px;
  }
  @media (max-width: 700px) {
    padding: 25px 35px 10px 35px;
    width: calc(100% - 70px);

    height: auto;
    font-size: 23px;
    line-height: 28px;
    letter-spacing: 0.3px;
    text-align: center;

    position: relative;
    left: 0;
    top: 0;
    float: left;
  }
`;
const TopLink = styled.a`
  position: absolute;
  top: 67px;
  right: calc(50% - 520px);

  height: 17px;
  font-family: Lato;
  font-size: 14px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 1px;
  text-align: center;
  color: #ff5368;

  text-transform: uppercase;
  text-decoration: none;

  @media (max-width: 1100px) {
    top: 31px;
    right: 25px;

    height: 15px;
    font-size: 12px;
    letter-spacing: 0.8px;
  }
  @media (max-width: 700px) {
    padding: 0 35px 30px 35px;
    width: calc(100% - 70px);

    height: auto;
    font-size: 12px;
    line-height: 15px;
    letter-spacing: 0.8px;
    text-align: center;

    position: relative;
    right: 0;
    top: 0;
    float: left;
  }
`;
const Inner = styled.div`
  width: calc(100% - 50px);
  margin: 25px;
  float: left;
  background-image: url("/assets/noise-pattern@2x.png");
  background-size: 200px 200px;
  padding: 40px 0 97px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  position: relative;
  @media (max-width: 1100px) {
    padding: 35px 0 90px 0;
  }
  @media (min-width: ${lotCutOff}px) {
    a.lot:nth-child(n + 9) {
      display: none;
      height: 0;
      width: 0;
      overflow: hidden;
    }
  }
  @media (max-width: ${lotCutOff}px) {
    a.lot:nth-child(n + 7) {
      display: none;
      height: 0;
      width: 0;
      overflow: hidden;
    }
  }
  @media (max-width: 700px) {
    padding: 29px 0 90px 0;

    width: 100%;
    margin: 0;

    background-image: none;
    background-color: #f9f9f9;
  }
`;
const BottomLink = styled.a`
  position: absolute;
  width: 100%;
  bottom: 74px;
  left: 0;

  height: 17px;
  font-family: Lato;
  font-size: 14px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 1px;
  text-align: center;
  color: #ff5368;

  text-transform: uppercase;
  text-decoration: none;

  @media (max-width: 1100px) {
    bottom: 70px;

    height: 15px;
    font-size: 12px;
    letter-spacing: 0.8px;
  }
  @media (max-width: 700px) {
    height: auto;
    line-height: 15px;
    text-align: center;

    bottom: 39px;
  }
`;

class HappeningNow extends Component {
  render() {
    let lots = [];
    let auctionBaseUrl = "/portal";
    if (
      this.props.auction &&
      this.props.auctions &&
      this.props.featured &&
      this.props.auctions[this.props.auction] &&
      this.props.auctions[this.props.auction].url &&
      this.props.featured[this.props.auction] &&
      this.props.featured[this.props.auction].small
    ) {
      lots = this.props.featured[this.props.auction].small;
      auctionBaseUrl = this.props.auctions[this.props.auction].url;
    }
    return (
      <Wrapper>
        <Title>Happening now</Title>
        <TopLink href={auctionBaseUrl + "/auction"}>
          Online catalogue {">"}
        </TopLink>
        <Inner>
          {lots.map(lot => (
            <Lot auctionBaseUrl={auctionBaseUrl} content={lot} key={lot.id} />
          ))}
        </Inner>
        <BottomLink href={auctionBaseUrl + "/auction"}>See more</BottomLink>
      </Wrapper>
    );
  }
}

const mapStateToProps = state => {
  return {
    auction: state.auction.data,
    auctions: state.auctions.data,
    featured: state.featured.data
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onTodoClick: id => {
      dispatch({ type: "NONE" });
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HappeningNow);



// WEBPACK FOOTER //
// ./src/components/HappeningNow.js